import { LaunchDarklyFlag, useFlag, useLDContext } from 'state/launchdarkly';
import { staticLDFlags } from 'state/launchdarkly/launchdarkly-core';
import { AppTakeover } from 'state/launchdarkly/variations';

import { spongebob } from './spongebob/spongebob';

// TODO define an official real type if we do another takeover
type AppTakeoverType = typeof spongebob;

// add additional takeovers here
const appTakeoverConfigs: Record<string, AppTakeoverType> = {
  spongebob,
};

/** get a takeover if one is active per LD date ranges */
export const useAppTakeover = (): Partial<AppTakeoverType & { isTakeoverActive: boolean }> => {
  const ldContext = useLDContext();

  const contextReadResult = useFlag(LaunchDarklyFlag.APP_TAKEOVER);

  // read from static flags which happens before
  const appTakeover = (ldContext && ldContext.isInitialized
    ? contextReadResult
    : staticLDFlags.current[LaunchDarklyFlag.APP_TAKEOVER]) as AppTakeover;

  if (appTakeover && appTakeover.length) {
    const now = new Date();
    const activeTakeover = appTakeover.find(takeover => {
      const start = new Date(takeover.startDate);
      const end = new Date(takeover.endDate);
      return now >= start && now <= end;
    });
    if (activeTakeover) {
      return { ...appTakeoverConfigs[activeTakeover.name], isTakeoverActive: true };
    }
  }
  return { isTakeoverActive: false };
};

/** return a SHP config if takeover is active for the passed home page */
export const useAppTakeoverSimpleHomePage = (
  homePageId: string
): Partial<AppTakeoverType['homePage'] & { isTakeoverActive: boolean }> => {
  const appTakeover = useAppTakeover();

  if (!homePageId) {
    return { isTakeoverActive: false };
  }

  if (appTakeover?.homePage?.targetSimpleHomePageIds?.includes(homePageId)) {
    return { ...appTakeover?.homePage, isTakeoverActive: true };
  }
  return {};
};

/** returns a PDP config if takeover is active for the menu item */
export const useAppTakeoverPdp = (
  itemId: string
): Partial<AppTakeoverType['pdp'] & { isTakeoverActive: boolean }> => {
  const appTakeover = useAppTakeover();

  if (!itemId) {
    return {};
  }

  if (appTakeover?.pdp?.targetMenuItemIds?.includes(itemId)) {
    return { ...appTakeover?.pdp, isTakeoverActive: true };
  }

  return {};
};
